<template>
    <div v-if="dataList.length>0">
        <div v-for="(item, index) in dataList" :key="index" v-show="item.hasAmount > 0 && isNextTick" class="con">
            <h4>
                <div @click="openRewardPointContentModal(item)" class="d-flex">
                    <span>
                        目前 <b>{{item.rewardPointListName}}</b>
                    </span>
                    <span class="ps">
                        <i class="el-icon-question i-info"/>
                        <span class="gray"> / 可折 {{item.useMaxAmount}}</span>
                    </span>
                </div>

                <el-button type="text" :disabled="item.isDisabled" @click="useMaxAmountEvent(item, index)">全抵</el-button>
            </h4>

            <div class="input">
                <NumberController :size="'mini'" :params="numberControllerParams(item)" @triggerEvent="numberControllerEvent($event, item, index)"/>
            </div>
        </div>

        <el-dialog
                :visible.sync="rewardPointContentModal"
                :show-close="false"
                append-to-body
                custom-class="commDialog">
            <div class="container">
                <h4 class="text-center">點數折抵現金比例說明</h4>
                <el-divider class="mt-0"/>
                <div class="text-center">{{rewardPointContentData.rewardPointListName}}</div>
                <div class="text-center">每<span class="red">{{rewardPointContentData.rewardPointListPoint}}</span>點可折抵<span class="red">{{rewardPointContentData.rewardPointListDiscount}}</span>元</div>
                <div class="text-center" v-html="rewardPointContentData.content"></div>
                <div class="text-center red" v-if="!rewardPointContentData.isDiscountShare">不與其他優惠共用</div>
                <div class="dialog-footer">
                    <el-button type="primary" @click="rewardPointContentModal = false">確定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import NumberController from '@/components/NumberController'

    export default {
        name: "BonusPoints",
        props: ['list'],
        components: {
            NumberController,
        },
        data() {
            return {
                rewardPointContentModal: false,
                dataList: [],
                rewardPointContentData: {},       //紅利點數說明資料
                isNextTick: false,
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            numberControllerEvent(obj, item, index) {
                let event = obj.event;
                if (event === "returnNumber") {
                    this.$emit("triggerEvent",{
                        event: 'calculatorCallBack',
                        number: obj.number,
                        item: item,
                        index: index,
                    })
                }
            },
            onDialogResult() {
                this.rewardPointContentModal = false;
            },
            openRewardPointContentModal(item) {
                let useSetting = item.useSetting
                this.rewardPointContentData = item
                let content = ""
                if(useSetting.isMaxDiscount) {
                    content += `單筆折抵上限為<span class="red">${this.$public.numberFormat(useSetting.maxDiscount)}</span>元，`
                }

                switch (useSetting.discountLimitType) {
                    case 1:
                        content += `消費無限制使用`
                        break;
                    case 2:
                        content += `需單筆消費滿<span class="red">${this.$public.numberFormat(useSetting.percentQuotaAmount)}</span>元，小計最多可用<span class="red">${this.$public.numberFormat(useSetting.percentQuota)}</span>%點數折抵`
                        break;
                    case 3:
                        content += `需單筆消費滿<span class="red">${this.$public.numberFormat(useSetting.fixedQuotaAmount)}</span>元，可用點數折抵<span class="red">${this.$public.numberFormat(useSetting.fixedQuota)}</span>元`
                        content += useSetting.isCumulative ? `(可累計)` : ``;
                        break;
                }

                this.rewardPointContentData.content = content
                this.rewardPointContentModal = true;
            },
            numberControllerParams(item) {
                return {
                    default: (item.isUse ? item.useAmount : 0),
                    min: 0,
                    max: item.useMaxAmount,
                    isDisabled: item.isDisabled,
                }
            },
            useMaxAmountEvent(item, index) {
                this.$emit("triggerEvent",{
                    event: 'calculatorCallBack',
                    number: item.useMaxAmount,
                    item: item,
                    index: index,
                })
            },
        },
        watch: {
            'list':{
                handler: function () {
                    this.isNextTick = false
                    this.dataList = JSON.parse(JSON.stringify(this.list));
                    this.$nextTick(() => {
                        this.isNextTick = true
                    })
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>

<style lang="less" scoped>
    .con{
        margin-bottom: 20px;
        &:last-child{
            margin-bottom: 0;
        }
        h4{
            .d-flex{
                align-items: center;
            }
            .gray{
                color: var(--color-dark);
                font-size: 12px;
            }
            .ps{
                white-space:nowrap;
                margin-right: 20px;
            }
        }
    }
    .input{
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        /deep/.amount{
            display: block;
            width: inherit;
            flex: 1 !important;
            position: relative;
            .el-input{
                width: 100% !important;
            }
            .el-input__inner{
                text-align: right!important;
                width: 100%;
                border: 1px solid #ccc !important;
                height: 32px;
                padding: 0 8px!important;
                line-height: 30px;
            }
            .el-button{
                display: none;
            }
        }

    }
</style>
